import { computed, ref, onMounted } from 'vue';
import { TenantConfig } from '../types/tenant-config';
import TenantConfigService from '../services/tenant-config-service';

export function useTenantConfig() {
    const config = ref<TenantConfig | null>(null);
    const isLoaded = ref(false);
    const error = ref<string | null>(null);

    const loadConfig = () => {
        try {
            config.value = TenantConfigService.getCurrentTenantConfig();
            isLoaded.value = true;
            error.value = null;
        } catch (err) {
            console.error('[useTenantConfig] Failed to load tenant config:', err);
            error.value = err instanceof Error ? err.message : 'Unknown error';
            isLoaded.value = false;
        }
    };

    // Direct property access with full IntelliSense and type safety
    const branding = computed(() => TenantConfigService.branding);
    const content = computed(() => TenantConfigService.content);
    const features = computed(() => TenantConfigService.features);
    const urls = computed(() => TenantConfigService.urls);
    const settings = computed(() => TenantConfigService.settings);

    //// Utility computed properties for common use cases
    //const isDarkTheme = computed(() => {
    //    const primaryColor = branding.value.primaryColor;
    //    // Simple check if color is dark (you can enhance this logic)
    //    return primaryColor.includes('#1') || primaryColor.includes('#2') || primaryColor.includes('#3');
    //});

    onMounted(() => {
        loadConfig();
    });

    return {
        // Raw config and state
        config: computed(() => config.value),
        isLoaded: computed(() => isLoaded.value),
        error: computed(() => error.value),

        // Typed property access
        branding,
        content,
        features,
        urls,
        settings,

        // Utility properties
   /*     isDarkTheme,*/

        // Methods
        loadConfig,
        clearCache: () => TenantConfigService.clearCache()
    };
}